import React, { useState, useRef, useEffect } from "react";
// import { Row, Col, Dropdown, Button, Modal, Container, Card } from 'react-bootstrap';

import { Dropdown, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  Button,
  Row,
  Col,
  Table,
} from "reactstrap";
import * as XLSX from "xlsx";
import PageTitle from "../../layouts/PageTitle";
import {
  deleteEmployeApi,
  getEmployeesApi,
  UpdateEmployeeStatus,
} from "../../../services/apis/EmployeeApi";
import Loader from "../../components/Loader/Loader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import { Toaster } from "../../components/Toaster/Toster";
import ReactPaginate from "react-paginate";
import SingleDeleteWarningMdl from "../../components/common/SingleDeleteWarningMdl";
import {
  isMobile,
  isTablet,
  isDesktop,
  isAndroid,
  isIOS,
} from "react-device-detect";
import { CreatelogActivityApi } from "../../../services/apis/IpAddress";
import { useSelector } from "react-redux";
import moment from "moment";
import Switch from "react-switch";

const holidayTable = [
  {
    id: 1,
    sno: "01",
    employeeName: "John Doe",
    phone: "+91-8000-234-234",
    email: "john@example.com",
    createdAt: "01/10/2024",
  },
];

const theadData = [
  { heading: "S.No.", sortingVale: "sno",},
  { heading: "Employee Name", sortingVale: "employeeName" },
  { heading: "Role", sortingVale: "role" },
  { heading: "Mobile", sortingVale: "mobile" },
  { heading: "Email", sortingVale: "email" },
  { heading: "Created At", sortingVale: "createdAt" },
  { heading: "Status", value: "status", sortingVale: "status" },
  { heading: "Action", sortingVale: "action" },
];

const excelHeadData = [
  { heading: "S.No.", value: "s.no.", sortingVale: "sno" },
  { heading: "Employee Name", value:"name", sortingVale: "employeeName" },
  { heading: "Role", sortingVale: "role" },
  { heading: "Mobile", value:"mobile", sortingVale: "mobile" },
  { heading: "Email", value:"email", sortingVale: "email" },
  { heading: "Created At", value:"createdAt", sortingVale: "createdAt" },
  { heading: "Action", value:"action", sortingVale: "action" },
];

const permission = [
  {
    _id: "658403b68ecdd0c7b0837d46",
    permission_name: "Create Hotel",
    route: "create-hotel",
    module_name: "Hotel",
    type: "Create",
  },
  {
    _id: "663232c421bc44964a792db4",
    permission_name: "View Sidebar Menu",
    description: "Permission to view Sidebar menu",
    route: "sidebar-menus",
  },
  {
    _id: "6634799563d4ea8933f94db5",
    permission_name: "View Hotels",
    route: "hotels-list",
    module_name: "Hotel",
    type: "View",
  },
  {
    _id: "663479ee63d4ea8933f94db8",
    permission_name: "Delete Hotels",
    route: "delete-hotel",
    module_name: "Hotel",
    type: "Delete",
  },
  {
    _id: "66347a1363d4ea8933f94db9",
    permission_name: "CreateRoom",
    route: "create-room",
    module_name: "Room",
    type: "Create",
  },
  {
    _id: "6635b95b5719d91165748842",
    permission_name: "Edit Hotels",
    route: "edit-hotel",
    module_name: "Hotel",
    type: "Edit",
  },
  {
    _id: "6645ab1dee0270ccb9e40b59",
    permission_name: "View Rooms",
    route: "room-list",
    module_name: "Room",
    type: "View",
  },
  {
    _id: "6645c6f9ee0270ccb9e40b5e",
    permission_name: "Edit Room",
    route: "edit-room",
    module_name: "Room",
    type: "Edit",
  },
  {
    _id: "6645c7edee0270ccb9e40b62",
    permission_name: "Delete Room",
    route: "delete-room",
    module_name: "Room",
    type: "Delete",
  },
  {
    _id: "6645cfebee0270ccb9e40b67",
    permission_name: "View Room Category",
    route: "roomcategory-list",
    module_name: "Room Category",
    type: "View",
  },
  {
    _id: "6645d5f3ee0270ccb9e40b6a",
    permission_name: "Edit Room Category",
    route: "edit-roomcategory",
    module_name: "Room Category",
    type: "Edit",
  },
  {
    _id: "6645da36ee0270ccb9e40b72",
    permission_name: "Delete Room Category",
    route: "delete-roomcategory",
    module_name: "Room Category",
    type: "Delete",
  },
  {
    _id: "6645db6cee0270ccb9e40b77",
    permission_name: "Create Room Category",
    route: "create-roomcategory",
    module_name: "Room Category",
    type: "Create",
  },
  {
    _id: "6646f18a8b5abae7db63704e",
    permission_name: "Create Hotel Category",
    route: "create-hotelcategory",
    module_name: "Hotel Category",
    type: "Create",
  },
  {
    _id: "6646f1ac8b5abae7db63704f",
    permission_name: "Edit Hotel Category",
    route: "edit-hotelcategory",
    module_name: "Hotel Category",
    type: "Edit",
  },
  {
    _id: "6646f1c48b5abae7db637050",
    permission_name: "View Hotel Category",
    route: "hotelcategory-list",
    module_name: "Hotel Category",
    type: "View",
  },
  {
    _id: "6646f1e38b5abae7db637051",
    permission_name: "Delete Hotel Category",
    route: "delete-hotelcategory",
    module_name: "Hotel Category",
    type: "Delete",
  },
];

const EmployeeList = () => {
  const [sort, setSortata] = useState(10);
  const [modalCentered, setModalCentered] = useState(false);
  const [logo, setLogo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchInputValue, setSearchInputValue] = useState("");
  const [showDeleteMdl, setShowDeleteMdl] = useState(false);
  const [deleteTableDataId, setDeleteTableDataId] = useState("");
  const informationIp = useSelector(
    (data) => data?.ipAddressReducers?.ipAddressData
  );
  const user = useSelector((data) => data?.userReducers?.user);
  const deviceType = {
    type: isMobile
      ? "Mobile"
      : isTablet
      ? "Tablet"
      : isDesktop
      ? "Desktop"
      : "Unknown",
    os: isAndroid ? "Android" : isIOS ? "iOS" : "Other",
  };

  const [data, setData] = useState(
    document.querySelectorAll("#holidayList tbody tr")
  );
  const activePag = useRef(0);
  const [test, settest] = useState(0);
  const [employeeData, setEmployeeData] = useState();
  const [allEmployeeData, setAllEmployeeData] = useState([]);
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };

  useEffect(() => {
    setData(document.querySelectorAll("#holidayList tbody tr"));
  }, [test]);

  const fetchEmployees = async (sortValue) => {
    setLoading(true);
    try {
      const res = await getEmployeesApi(
        currentPage,
        sort,
        sortValue,
        searchInputValue
      );
      // console.log(res?.data, "roles is here");
      
      const limit = 1500;
      const resData = await getEmployeesApi(
        1,
        limit,
        sortValue,
        searchInputValue
      );
      setAllEmployeeData(resData?.data?.employees)
      setEmployeeData(res?.data);
      // setUpdateRoles(false)
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmployees();
  }, [currentPage, sort, searchInputValue]);

  // Handle the logo image change
  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setLogo(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  activePag.current === 0 && chageData(0, sort);

  let paggination = Array(Math.ceil(data.length / sort)).fill().map((_, i) => i + 1);

  const [feeData, setFeeDate] = useState([...holidayTable]);
  const [iconData, setIconDate] = useState({ complete: false, ind: Number });

  function SotingData(name) {
    if (iconData.complete) {
      const sortValue = { value: name, type: "asc" };
      fetchEmployees(sortValue);
    } else {
      const sortValue = { value: name, type: "dsc" };
      fetchEmployees(sortValue);
    }
  }

  const styles = {
    container: {
      border: "2px dashed #ccc",
      borderRadius: "8px",
      width: "150px", // Logo size
      height: "150px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      backgroundColor: "#f9f9f9",
      position: "relative",
      textAlign: "center",
      overflow: "hidden",
    },
    coverContainer: {
      border: "2px dashed #ccc",
      borderRadius: "8px",
      width: "300px", // Cover size (2:1 ratio)
      height: "150px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      backgroundColor: "#f9f9f9",
      position: "relative",
      textAlign: "center",
      overflow: "hidden",
    },
    placeholder: {
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      textAlign: "center",
    },
    img: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderRadius: "8px",
    },
    hover: {
      borderColor: "#007bff",
      backgroundColor: "#e9f4ff",
    },
    uploadIcon: {
      color: "#888",
      fontSize: "16px",
      fontWeight: "bold",
    },
  };
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen1, setIsOpen1] = useState(false);
  const [selectedModuleIds, setSelectedModuleIds] = useState([]);
  const [selectedPermissionIds, setSelectedPermissionIds] = useState([]);

  // Organize permissions data by module and type
  const permissionData = {};
  permission?.forEach((perm) => {
    const { module_name, type } = perm;
    if (!permissionData[module_name]) {
      permissionData[module_name] = {};
    }
    if (!permissionData[module_name][type]) {
      permissionData[module_name][type] = [];
    }
    permissionData[module_name][type].push(perm);
  });

  const toggleCollapse = () => {
    setIsOpen(!isOpen);
  };

  const toggleCollapse1 = () => {
    setIsOpen1(!isOpen1);
  };

  const handlePageClick = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
  };

  const handleDeleteRole = (id) => {
    setDeleteTableDataId(id);
    setShowDeleteMdl(true);
  };

  const loggedActivity = async () => {
    const data = {
      id: user?._id,
      ipAddress: informationIp?.query,
      lat: informationIp?.lat,
      long: informationIp?.lon,
      logType: "employeedelete",
      deviceType: JSON.stringify(deviceType),
      city: informationIp?.city,
      countryCode: informationIp?.countryCode,
      regionCode: informationIp?.region,
    };
    try {
      await CreatelogActivityApi(data);
    } catch (err) {
      console.log(err);
    }
  };

  const handleDeleteSubmit = async () => {
    try {
      const res = await deleteEmployeApi(deleteTableDataId);
      if (res?.data?.success) {
        Toaster.success(res?.data?.message);
        setShowDeleteMdl(false);
        fetchEmployees();
        loggedActivity();
      }
    } catch (err) {
      // console.log(err)
      Toaster.error(err.response?.data?.message);
    }
  };

  const convertToGeneralFormat = (number) => {
    if (number?.toString().includes("e")) {
      return Number(number).toLocaleString("fullwide", { useGrouping: false });
    }
    return number; // Return the number as is if it's not in scientific notation
  };

    const exportToExcel = () => {
      const table = document.querySelector("table");
  
      if (!allEmployeeData || allEmployeeData.length === 0) {
        alert("No valid data to export.");
        return;
      }
  
      const headers = excelHeadData
        ?.filter(
          (item) =>
            item?.value !== "s.no." &&
            item?.value !== "createdAt" &&
            item?.value !== "status" &&
            item?.value !== "action"
        )
        ?.map((item) => `<th>${item?.value}</th>`)
        ?.join("");

      const rows = allEmployeeData
        ?.map((data, ind) => {
          const convertedNumber = convertToGeneralFormat(data?.mobile);
          return `
          <tr>
            <td>${data?.username}</td>
            <td>${data?.role?.name}</td>
            <td>${convertedNumber}</td>
            <td>${data?.email}</td>
          </tr>
        `;
        })
        .join("");
  
      const updatedTable = document.createElement("table");
      updatedTable.innerHTML = 
      `<thead><tr>${headers}</tr></thead>
        <tbody>${rows}</tbody>`;
  
      const workbook = XLSX.utils.table_to_book(updatedTable, {
        sheet: "UserList",
      });
      XLSX.writeFile(workbook, "UserList.xlsx");
      loggedActivity("export")
    };

      const handleStatusChange = async (Id, currentStatus) => {
        const fdata = {
          status: !currentStatus,
        };
        try {
          const res = await UpdateEmployeeStatus(Id, fdata);
          if (res.status === 200) {
            Toaster.success(res?.data?.message); // Display success message
            fetchEmployees();
          } else {
            Toaster.error(
              res?.data?.message || "Something went wrong. Please try again."
            );
          }
        } catch (err) {
          console.log(err);
        }
      };

  return (
    <>
      <SingleDeleteWarningMdl
        title={"table data"}
        showDeleteMdl={showDeleteMdl}
        setShowDeleteMdl={setShowDeleteMdl}
        setDeleteTableDataId={setDeleteTableDataId}
        handleDeleteSubmit={handleDeleteSubmit}
      />
      <ToastContainer />
      <Loader visible={loading} />
      <PageTitle activeMenu={"Employee List"} motherMenu={"Employees"} />
      <Row>
        <Col lg={12}>
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Employee List</h4>
              {/* <Link to={"/add-staff"} className="btn btn-primary">+ Add New</Link> */}
              <Button
                variant="primary"
                type="button"
                className="mb-2 me-2"
                onClick={exportToExcel}>
                Export
              </Button>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <div id="holidayList" className="dataTables_wrapper no-footer">
                  <div className="justify-content-between d-sm-flex">
                    <div className="dataTables_length">
                      <label className="d-flex align-items-center">
                        Show
                        <Dropdown className="search-drop">
                          <Dropdown.Toggle as="div" className="search-drop-btn">
                            {sort}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item onClick={() => setSortata("2")}>
                              2
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => setSortata("5")}>
                              5
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => setSortata("10")}>
                              10
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => setSortata("15")}>
                              15
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => setSortata("20")}>
                              20
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                        Entries
                      </label>
                    </div>
                    <div className="dataTables_filter">
                      <label>
                        Search :
                        <input
                          type="search"
                          className=""
                          placeholder=""
                          onChange={(e) => setSearchInputValue(e.target.value)}
                        />
                      </label>
                    </div>
                  </div>
                  <table
                    id="example4"
                    className="display dataTable no-footer w-100">
                    <thead>
                      <tr>
                        {theadData?.map((item, ind) => (
                          <th
                            key={ind}
                            onClick={() => {
                              SotingData(item.sortingVale);
                              setIconDate((prevState) => ({
                                complete: !prevState.complete,
                                ind: ind,
                              }));
                            }}>
                            {item.heading}
                            <span>
                              {ind !== iconData.ind && (
                                <i
                                  className="fa fa-sort ms-2 fs-12"
                                  style={{ opacity: "0.3" }}
                                />
                              )}
                              {ind === iconData.ind &&
                                (iconData.complete ? (
                                  <i
                                    className="fa fa-arrow-down ms-2 fs-12"
                                    style={{ opacity: "0.7" }}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-arrow-up ms-2 fs-12"
                                    style={{ opacity: "0.7" }}
                                  />
                                ))}
                            </span>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {employeeData?.employees?.map((data, ind) => (
                        <tr key={ind}>
                          <td>
                            {/* <strong>{ind + 1}</strong> */}
                            <strong>{(currentPage - 1) * sort + ind + 1}</strong>
                          </td>
                          <td>{data?.username}</td>
                          {/* <td>{`${data?.firstName} ${data?.lastName}`}</td> */}
                          <td>{data?.role?.name}</td>
                          <td>{data?.mobile}</td>
                          <td>{data?.email}</td>
                          <td>
                            {moment(data?.createdAt).format(
                              "DD MMM YYYY, h:mm:ss a"
                            )}
                          </td>
                          <td>
                            <Switch
                              checked={data?.isActive}
                              onChange={()=> handleStatusChange(data?._id, data?.isActive)}
                              offColor="#f0f3ff"
                              onColor="#475cff"
                              offHandleColor="#6a73fa"
                              onHandleColor="#fff"
                              uncheckedIcon={false}
                              checkedIcon={false}
                              width={40} // Adjust width of the switch
                              height={20} // Adjust height of the switch
                            />
                          </td>
                          <td>
                            <Link
                              className="btn btn-xs sharp secondary me-1"
                              to={`/edit-employee/${data?._id}`}>
                              <i className="fa fa-pencil" />
                            </Link>
                            <button
                              className="btn btn-xs sharp btn-danger"
                              onClick={() => handleDeleteRole(data?._id)}>
                              <i className="fa fa-trash" />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="d-sm-flex text-center justify-content-end align-items-center mt-3">
                    <div className="pagination-container">
                      <ReactPaginate
                        pageCount={Math.ceil(
                          employeeData?.totalEmployees /
                            employeeData?.rowPerPage
                        )}
                        pageRangeDisplayed={1}
                        marginPagesDisplayed={2}
                        onPageChange={handlePageClick}
                        containerClassName="pagination"
                        activeClassName="selected"
                        disabledClassName="disabled"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Modal --> */}
          <Modal
            className="fade"
            show={modalCentered}
            onHide={setModalCentered}
            centered>
            <Modal.Header>
              <Modal.Title>+ Add new cuisine</Modal.Title>
              <Button
                onClick={() => setModalCentered(false)}
                variant=""
                className="btn-close"
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <div className="col-xl-12 col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div>
                      <div className="mb-3 row">
                        <div className="col-sm-12">
                          <label className="col-sm-3 col-form-label">
                            Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="New cuisine"
                          />
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <div className="col-sm-12">
                          <label className="col-form-label">
                            Cuisine image
                          </label>
                          <div style={styles.container}>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={handleLogoChange}
                              style={{ display: "none" }}
                              id="logoUpload"
                            />
                            <label
                              htmlFor="logoUpload"
                              style={styles.placeholder}>
                              {logo ? (
                                <img src={logo} alt="Logo" style={styles.img} />
                              ) : (
                                <div style={styles.uploadIcon}>
                                  Upload Image
                                </div>
                              )}
                            </label>
                          </div>
                          <p>
                            Image format - jpg png jpeg gif
                            <br />
                            Image Size - maximum size 2 MB
                            <br />
                            Image Ratio - 1:1
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                onClick={() => setModalCentered(false)}
                variant="danger light">
                Close
              </Button>
              <Button variant="primary">Save changes</Button>
            </Modal.Footer>
          </Modal>
        </Col>
      </Row>
    </>
  );
};

export default EmployeeList;
